import { Component, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-outpost",
  templateUrl: "./outpost.component.html",
  styleUrls: ["./outpost.component.scss"],
})
export class OutpostComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
